/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { css } from '@emotion/react'

import { shade } from '@elastic/eui'
import type { UseEuiTheme } from '@elastic/eui'

export const filterClausesStyles = css`
  list-style-type: none;
  margin: 0;
  padding: 0 0 0.5rem;

  & & {
    margin: 0 0 0 7.2rem;
  }
`

export const filterClauseOuterStyles = ({ euiTheme }: UseEuiTheme) => css`
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    border-left: 2px solid ${shade(euiTheme.colors.lightestShade, 0.04)};
    height: 100%;
    position: absolute;
    left: 3rem;
    bottom: 0;
    z-index: -1;

    .euiTheme-dark & {
      border-color: ${euiTheme.colors.mediumShade};
    }
  }
`

export const nestedFilterClauseStyles = css`
  margin-top: -1px;
`

export const filterClauseDetailsStyles = ({ euiTheme }: UseEuiTheme) => css`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border: 1px solid ${shade(euiTheme.colors.lightestShade, 0.06)};
  margin-bottom: 0.625rem;

  & + & {
    margin-bottom: 0;
    margin-top: -1px;
  }

  .euiTheme-dark & {
    border-color: ${euiTheme.colors.mediumShade};
  }
`

export const filterClauseConnectorStyles = ({ euiTheme }: UseEuiTheme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${euiTheme.colors.lightestShade};
  border-right: 1px solid ${shade(euiTheme.colors.lightestShade, 0.06)};
  width: 6rem;

  .euiTheme-dark & {
    background-color: ${shade('#243147', 0.143)};
    border-color: ${euiTheme.colors.mediumShade};
  }
`

export const filterClauseFieldsStyles = ({ euiTheme }: UseEuiTheme) => css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: ${euiTheme.size.base};

  input {
    padding: 6px 10px;
    box-shadow: none;
    border-right: 1px solid ${shade(euiTheme.colors.lightestShade, 0.06)};
    border-left: 1px solid ${shade(euiTheme.colors.lightestShade, 0.06)};
    border-radius: 0;
  }
`

export const filterClauseFieldsEqualToStyles = ({ euiTheme }: UseEuiTheme) => css`
  white-space: nowrap;
  padding: 0 ${euiTheme.size.m};
`

export const removeClauseStyles = ({ euiTheme }: UseEuiTheme) => css`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  padding: ${euiTheme.size.xs};
`

export const filterClauseActionsStyles = css`
  > * {
    display: inline-block;
    margin-right: 0.5rem;
  }
`
